import { Controller } from '@hotwired/stimulus'
import Plyr from 'plyr'
import '../mediamtx_reader'

const urlTemplate = 'https://marika.selanastudios.com:8889/{{camera}}_{{quality}}/whep'
const username = 'dimitris'
const password = 'aneta1993'

export default class extends Controller {
  static values = {
    camera: String,
    quality: { type: String, default: 'sub' }
  }

  #reader = null
  #plyr = null
  #qualityButton = null

  get #streamUrl() {
    return urlTemplate
      .replace('{{camera}}', this.cameraValue)
      .replace('{{quality}}', this.qualityValue)
  }

  connect() {
    this.#loadReader()
    this.#loadPlyr()
    this.#addQualityToggle()

    window.addEventListener('beforeunload', this.#close)
  }

  disconnect() {
    window.removeEventListener('beforeunload', this.#close)

    this.#close()
  }

  #loadReader = () => {
    this.#reader = new MediaMTXWebRTCReader({
      url: this.#streamUrl,
      user: username,
      pass: password,
      token: '',
      onError: (err) => {
        console.error(err)
      },
      onTrack: (evt) => {
        this.element.srcObject = evt.streams[0]
        this.element.play().catch(() => {
          // Show play button or controls if autoplay fails
          this.element.setAttribute('controls', '')
        })
      }
    })
  }

  #loadPlyr = () => {
    this.#plyr = new Plyr(this.element, {
      // controls: ['play-large', 'play', 'mute', 'volume', 'fullscreen'],
      controls: ['play-large', 'fullscreen'],
      muted: true,
      autoplay: true,
      clickToPlay: true,
      hideControls: true,
      resetOnEnd: false,
      // Disable features that don't apply to live streams
      keyboard: { focused: true, global: false },
      tooltips: { controls: true, seek: false },
      // No progress bar for live streams
      settings: []
    })
  }

  #addQualityToggle = () => {
    const controls = this.#plyr.elements.controls
    const fullscreenBtn = controls?.querySelector('[data-plyr="fullscreen"]')

    if (!controls || !fullscreenBtn) return

    this.#qualityButton = document.createElement('button')
    this.#qualityButton.type = 'button'
    this.#qualityButton.className = 'plyr__controls__item plyr__control'
    this.#updateQualityButton()

    this.#qualityButton.addEventListener('click', this.#toggleQuality)

    fullscreenBtn.parentNode.insertBefore(this.#qualityButton, fullscreenBtn)
  }

  #updateQualityButton = () => {
    if (!this.#qualityButton) return

    const isHD = this.qualityValue === 'full'
    this.#qualityButton.innerHTML = isHD ? 'HD' : 'SD'
    this.#qualityButton.title = isHD ? 'Switch to SD' : 'Switch to HD'
    this.#qualityButton.style.cssText = `
      font-size: 12px;
      font-weight: bold;
      padding: 0 8px;
      opacity: ${isHD ? '1' : '0.7'};
    `
  }

  #toggleQuality = () => {
    this.qualityValue = this.qualityValue === 'sub' ? 'full' : 'sub'
    this.#updateQualityButton()
    this.#switchStream()
  }

  #switchStream = () => {
    this.#reader?.close()
    this.#loadReader()
  }

  #close = () => {
    this.#reader?.close()
  }
}
